<template>
    <v-container class="pa-0">
        <!-- FORMULARIO EDITAR PERFIL -->
        <v-row>
            <v-col cols="12" md="8">
                <div class="align-center d-flex mb-5">
                    <v-img max-width="120px" height="120px" class="rounded-circle " 
                        :src="user.avatar !== null ? `https://api.mylegis.com.br/assets/${user.avatar}` : require(`../assets/icon-person.svg`)" />
                    <v-avatar v-if="disabledCondition == false" color="grey" width="120" height="120" style="opacity:.75; margin-left:-120px">
                        <v-file-input filled prepend-icon="mdi-camera" dark hide-input v-model="img"
                            @change="handleImageAdded(img)"></v-file-input>
                    </v-avatar>
                    <div class="flex-column ml-2">
                        <h2>{{ user.first_name }} {{ user.last_name }}</h2>
                        <p class="mb-0 ml-1">{{ user.plano | plan }}</p>
                        <v-btn @click="disabledCondition = !disabledCondition" class="styleBtnEdit" text>
                            Editar Informações
                            <v-icon style="font-size: 18px; margin-left: 8px">mdi-pencil</v-icon>
                        </v-btn>
                    </div>
                </div>
                <div class="TitleAccordeon d-flex" @click="showCapa = !showCapa">
                    <h3 class="my-orange gt-bold d-flex align-center mb-0">
                        <v-icon class="icone">mdi-image</v-icon>Imagem de Capa
                    </h3>
                    <v-spacer></v-spacer>

                    <v-icon class="iconeExpansion">
                        {{ showCapa == true ? "mdi-chevron-up" : "mdi-chevron-down" }}
                    </v-icon>
                </div>
                <div :class="[
                    this.showCapa == true
                        ? 'contentAccordeonOpen'
                        : 'contentAccordeon',
                ]">
                    <v-img max-width="100%" height="280px"
                        :src="user.capa ? `https://api.mylegis.com.br/assets/${user.capa}` : ``"
                        ></v-img>
                        <div v-if="disabledCondition == false" style="background:grey; width:100%; height:280px; opacity:.75; margin-top:-280px; display:flex; align-items: center">
                            <v-file-input filled prepend-icon="mdi-camera" dark hide-input v-model="img"
                                @change="handleImageCapa(img)"></v-file-input>
                        </div>
                </div>
                <div class="TitleAccordeon d-flex" @click="showInfos = !showInfos">
                    <h3 class="my-orange gt-bold d-flex align-center mb-0">
                        <v-icon class="icone">mdi-account</v-icon>Informações pessoais
                    </h3>
                    <v-spacer></v-spacer>

                    <v-icon class="iconeExpansion">
                        {{ showInfos == true ? "mdi-chevron-up" : "mdi-chevron-down" }}
                    </v-icon>
                </div>
                <div :class="[
                        this.showInfos == true
                            ? 'contentAccordeonOpen'
                            : 'contentAccordeon',
                    ]">
                    <v-form class="text-center" :class="[
                        this.showInfos == true
                            ? 'contentAccordeonOpen'
                            : 'contentAccordeon',
                    ]" ref="form" v-model="valid" lazy-validation :disabled="!editForm">
                        <v-text-field v-model="first_name" :counter="30" :disabled="disabledCondition"
                            :rules="nameRules" label="Nome" color="#F15A24" required></v-text-field>

                        <v-text-field v-model="nickname" :counter="30" :disabled="disabledCondition"
                            label="Apelido" color="#F15A24" ></v-text-field>

                        <v-text-field v-model="email" :rules="emailRules" :disabled="true" label="E-mail"
                            required></v-text-field>

                        <v-text-field v-model="tags" color="#F15A24" :disabled="disabledCondition" label="Escritório / Instituição"
                            required></v-text-field>
                        <v-textarea color="#F15A24" :disabled="disabledCondition" label="Uma breve descrição para o seu perfil" v-model="descricao">
                        </v-textarea>

                        <v-btn v-if="disabledCondition == false" @click="updateUser()" :disabled="!editForm"
                            class="mx-auto styleSaveButton">
                            <v-icon>mdi-check</v-icon> Salvar Perfil
                        </v-btn>
                    </v-form>
                </div>

                <div class="TitleAccordeon d-flex" @click="showEndereco = !showEndereco">
                    <h3 class="my-orange gt-bold d-flex align-center mb-0">
                        <v-icon class="icone">mdi-map-marker</v-icon>Endereço
                    </h3>
                    <v-spacer></v-spacer>
                    <v-icon class="iconeExpansion">
                        {{ showEndereco == true ? "mdi-chevron-up" : "mdi-chevron-down" }}
                    </v-icon>
                </div>
                <div :class="[
                        this.showEndereco == true
                            ? 'contentAccordeonOpen'
                            : 'contentAccordeon',
                    ]">
                    <v-form :class="[
                        this.showEndereco == true
                            ? 'contentAccordeonOpen'
                            : 'contentAccordeon',
                    ]" ref="form" v-model="valid" lazy-validation :disabled="!editForm">
                        <v-row>
                            <v-col class="padCols" cols="12" md="6">
                                <v-text-field color="#F15A24" @blur="buscaCEP" v-mask="'#####-###'"
                                    v-model="address.cep" :disabled="disabledCondition" :rules="nameRules" label="CEP"
                                    required>
                                    <template v-slot:append-outer>
                                        <v-progress-circular v-if="loadingCEP" indeterminate
                                            :size="25"></v-progress-circular>
                                    </template>
                                </v-text-field>

                            </v-col>
                            <v-col class="padCols" cols="12" md="6">
                                <v-text-field color="#F15A24" :disabled="disabledCondition" v-model="address.estado"
                                    :rules="nameRules" label="Estado" required />
                            </v-col>
                        </v-row>

                        <v-text-field color="#F15A24" :disabled="disabledCondition" v-model="address.cidade"
                            label="Cidade" required />

                        <v-text-field color="#F15A24" :disabled="disabledCondition" v-model="address.bairro"
                            label="Bairro" required />

                        <v-row>
                            <v-col class="padCols" cols="12" md="6">
                                <v-text-field color="#F15A24" :disabled="disabledCondition" v-model="address.rua"
                                    :rules="nameRules" label="Rua" required />
                            </v-col>
                            <v-col class="padCols" cols="12" md="6">
                                <v-text-field color="#F15A24" :disabled="disabledCondition" v-model="address.numero"
                                    :rules="nameRules" label="Número" required />
                            </v-col>
                        </v-row>
                        <v-text-field color="#F15A24" :disabled="disabledCondition" v-model="address.complemento"
                            label="Complemento" />
                        <v-btn v-if="disabledCondition == false" @click="postAddress" :disabled="!editForm"
                            class="styleSaveButton">
                            Salvar
                        </v-btn>
                    </v-form>
                </div>


            </v-col>
            <v-col cols="12" md="4">
                <h5>Utilização do plano</h5>
                <p>
                    {{ sizeFiles | filesize }} de {{ maxStorage | filesize }}
                </p>
                <v-progress-linear :value="sizeFilesPercent" color="#F15A24" height="10"></v-progress-linear>
                <div class="TitleAccordeon d-flex" @click="showPagamento = !showPagamento">
                    <h3 class="my-orange gt-bold d-flex align-center">
                        <v-icon class="icone">mdi-file-sign</v-icon>Meu Plano
                    </h3>
                    <v-spacer></v-spacer>
                    <v-icon class="iconeExpansion">
                        {{ showPagamento == true ? "mdi-chevron-up" : "mdi-chevron-down" }}
                    </v-icon>
                </div>
                <div :class="[
                        this.showPagamento == true
                            ? 'contentAccordeonOpen'
                            : 'contentAccordeon',
                    ]">
                    <v-card v-if="subscriptions.length == 0">
                        <v-card-title>Nova Assinatura</v-card-title>
                        <v-card-text class="d-flex align-center justify-center flex-column">
                            Você ainda não possui uma assinatura ativa. Para iniciar, clique no botão abaixo e selecione
                            o plano
                            desejado.
                            <PaymentDialog :reloadSub="getUserLoggedPayments" :address="address" />
                        </v-card-text>
                    </v-card>
                    <v-card v-for="(subscription, i) in subscriptions" :key="i" class="styleCardPagamentos">

                        <v-card-title>
                            <span>
                                {{ subscription.plan.name }}
                            </span>
                            <v-spacer></v-spacer>
                            <span class="namePrice">
                                R$ {{ (subscription.items[0].pricing_scheme.price / 100).toLocaleString("pt-BR",
                        { minimumFractionDigits: 2 }
                    )
                                }}<small>/mês</small>
                            </span>
                        </v-card-title>
                        <v-card-text>
                            <v-list class="descPayment mt-0 pt-0">
                                <!-- <v-list-item>
                                    {{ subscription }}
                                </v-list-item> -->
                                <v-list-item>
                                    Criado em: {{ subscription.created_at | brdatetime }}

                                </v-list-item>
                                <v-list-item>
                                    Próxima cobrança: {{ subscription.next_billing_at | brdate }}
                                </v-list-item>
                                <v-list-item>
                                    Ciclo: {{ subscription.current_cycle.cycle }}

                                </v-list-item>
                                <v-list-item>
                                    Status: <b> {{ subscription.status === `failed` ? `falha no pagamento` :
                        subscription.status ===
                            `active` ? `ativo` : subscription.status }}</b> <v-btn outlined
                                        v-if="subscription.status == `failed`" small>Refazer pagamento</v-btn>

                                    <!-- {{ subscription.current_cycle.status }} -->

                                </v-list-item>
                                <v-list-item>
                                    {{ subscription.items[0].quantity }} x {{ subscription.items[0].name }} - {{
                        (subscription.items[0].quantity * subscription.items[0].pricing_scheme.price /
                            100).toLocaleString(
                                "pt-BR",
                                {
                                    minimumFractionDigits: 2,
                                }
                            ) }}
                                </v-list-item>
                                <div v-if="subscription.discounts">
                                    <p class="font-weight-bold mb-0 mt-3">Desconto </p><br>
                                    <p v-for="discount in subscription.discounts" :key="discount.id"> {{ discount.value
                                        }}{{
                        discount.discount_type === `percentage` ? `%` : ` reais` }} em {{
                        discount.cycles }}
                                        mensalidades </p>
                                </div>

                            </v-list>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn text color="#F15A24" dark class="inter" @click="editPlano = true">
                                <v-icon>mdi-plus</v-icon> Adquira mais espaço
                            </v-btn>
                        </v-card-actions>
                        <v-card-actions>
                            <v-btn text class="inter" x-small @click="deleteSubscription(subscription.id)">
                                CANCELAR
                            </v-btn>
                            <v-spacer></v-spacer>
                            <v-btn @click="changePlan = true" text class="mx-auto"><v-icon>mdi-refresh</v-icon> Trocar de
                                Plano</v-btn>
                        </v-card-actions>
                    </v-card>
                </div>

            </v-col>
            <!-- <v-col 
        v-if="intBreakPoint >= 2"
        class="d-flex justify-end" cols="12" md="4">
            <v-btn
            color="#F15A24"
            @click="disabledCondition = !disabledCondition"
            dark>
                Editar Informações<v-icon>mdi-pencil</v-icon>
            </v-btn>
        </v-col>     -->
        </v-row>
        <v-dialog width="510" v-model="editPlano">
            <v-card>
                <v-card-title>Alterar assinatura</v-card-title>
                <v-card-text>
                    <p> Hoje você utiliza <b>{{ sizeFiles | filesize }}</b> de <b>{{ maxStorage | filesize }}</b>
                        contratados,
                        utilize a barra abaixo para aumentar ou diminuir o tamanho do espaço contratado:</p>
                    <!-- <p class="mb-13">Selecione a quantidade de espaço desejado em gigabytes (GB):</p> -->
                    <v-slider color="#F15A24" track-color="#00000075" v-model="updatePlan.quantity" thumb-label="always"
                        :min="user.plano == `plano-carreira` ? 10 : 50"
                        :max="user.plano === `plano-carreira` ? 20 : 100"
                        :step="user.plano === `plano-carreira` ? 10 : 50" ticks="always" class="mt-15">
                    </v-slider>
                    <p v-if="subscriptions[0]">Nesta previsão no plano <b>{{ user.plano | plan }}</b> por <b>{{
                        updatePlan.quantity
                    }}GB</b> será cobrado o valor de <b>R${{ updatePlan.quantity / 10 * (user.plano ===
                        `plano-carreira`
                        ? 14.90 : 49.90) }}</b></p>
                </v-card-text>
                <v-card-actions class="d-flex align-center justify-center">
                    <v-btn @click="changeSubscription" :loading="loadingPlano" outlined>Atualizar assinatura</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog width="530" v-model="changePlan">
            <v-card>
                <v-card-title>Trocar de Plano</v-card-title>
                <v-card-text class="d-flex flex-column">
                    <p>Por favor selecione o plano desejado e confirme com o botao abaixo</p>
                    <v-btn-toggle color="#F15A24" class="mx-auto" v-model="planSelected" mandatory>
                        <v-btn x-large height="250px">
                            <!-- <span><v-icon x-large>mdi-scale-balance</v-icon><br> -->
                            Plano Carreira <br> 10GiB <br> R$14,90/mês
                         <!-- </span> -->
                        </v-btn>
                        <v-btn x-large  height="250px">
                            <!-- <span> -->
                            <!-- <v-icon x-large>mdi-account-circle-outline</v-icon><br> -->
                            Plano Premium<br />50GiB <br> R$49,90/mês
                        <!-- </span> -->
                        </v-btn>

                    </v-btn-toggle> </v-card-text>
                <v-card-actions class="d-flex align-center justify-center">
                    <v-btn @click="changeSubscription" :loading="loadingPlano" outlined>Trocar de Plano</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<style scoped>


.styleSaveButton {
    text-transform: none;
    background-color: #f15a24 !important;
    color: #ffffff;
    margin-top: 20px;
}

.padCols {
    padding: 5px 12px;
}

.icone {
    color: #f15a24;
    margin-right: 8px;
}

.TitleAccordeon {
    min-width: 100%;
    background-color: #ececec;
    padding: 10px 5px;
    margin: 5px 0px;
    cursor: pointer;
}

.contentAccordeon {
    max-height: 0px;
    min-width: 100%;
    display: none;
    padding: 10px 5px;
    transition: ease-in-out 1s;
}

.contentAccordeonOpen {
    max-height: auto;
    min-height: 280px;
    min-width: 100%;
    padding: 5px 5px;
    transition: ease-in-out 1s;
}

.styleCardPagamentos {
    min-height: 80px;
    min-width: 100%;
    margin: 20px 0px;
}

.namePayment {
    font-family: Inter;
    font-size: 20px;
    font-weight: 700;
    margin-bottom: 0px;
}


.descPayment {
    font-family: Inter;
    font-size: 16px;
    font-weight: 400;
}

.iconeExpansion {
    color: #f15a24;
    justify-content: right;
}

.positionBtnMobile {
    margin: 8px 0px 0px 20px;
}

.styleBtnEdit {
    padding: 0px 0px !important;
    text-transform: none;
    color: #f15a24;
}

.v-input__prepend-outer {
    margin: 0px !important;
}
</style>

<script>
import PaymentDialog from '../components/PaymentDialog.vue'
export default {
    name: "Perfil",
    components: { PaymentDialog },
    data() {
        return {
            editPlano: false,
            changePlan: false,
            files: [],
            loadingPlano: false,
            updatePlan: { quantity: 1 },
            img: null,
            first_name: this.$store.state.user.first_name,
            nickname: this.$store.state.user.apelido,
            email: this.$store.state.user.email,
            tags: this.$store.state.user.tags,
            local: this.$store.state.user.tags,
            descricao: this.$store.state.user.sobre,

            idNewAvatar: '',
            showInfos: true,
            showEndereco: false,
            showPagamento: false,
            disabledCondition: true,
            editForm: true,
            avatarData: "",
            valid: false,
            avatar: [],
            recentes: [],
            recenteAtivo: 0,
            sizeFiles: 0,
            sizeFilesPercent: 0,
            nameRules: [
                (v) => !!v || "Este campo é obrigatório",
                (v) =>
                    (v && v.length <= 40) || "Nome precisa ter menos de 40 caracteres",
            ],
            emailRules: [
                (v) => !!v || "Email é obrigatório",
                (v) => /.+@.+\..+/.test(v) || "Por favor digite um email válido.",
            ],
            addNewUser: false,
            loadingNewUser: false,
            newUser: {},
            showCapa: false,
            searchUsuarios: "",
            subscriptions: [],
            gerente: {},
            userPerguntas: [],
            userCommentArtigo: [],
            userCommentNoticia: [],
            planSelected: "",
            userCompartilhamentos: [],
            address: {
                id: "",
                cep: "",
                estado: "",
                cidade: "",
                bairro: "",
                rua: "",
                numero: "",
                complemento: ""
            },
            loadingCEP: false
        };
    },
    mounted() {
        this.reloadAvatar();
        //  this.getHistoricoUsuario()
        this.getUserLoggedPayments();
        this.getConsuption();
        this.getAddress()
        
    },
    computed: {
        maxStorage() {
            let plan = this.user.plano
            switch (true) {
                case (plan == "plano-free"):
                    return 52428800;
                case (["plano-avancado", "plano-carreira", "plan_XV7BG26TbcJoKxYv"].indexOf(plan) >= 0):
                    return 10737418240;
                case (["plano-premium", "plan_3B1DKr3HVqUp8LG5"].indexOf(plan) >= 0):
                    return 53687091200;
                case(["plan_lay6XlycO4TJw6e1", "plano-patrocinio"].indexOf(plan) >= 0): 
                    return 107374182400;
                default:
                    return 52428800;
            }
        },
        user() {
            // window.console.log(this.$store.state.user.avatar)
            return this.$store.state.user != undefined
                ? this.$store.state.user
                : { first_name: "Meu Perfil" };
        },
        role() {
            let role = this.$store.state.user.role;
            return role === "c4e091b9-1b89-477e-b7a2-2b37750c84e1"
                ? "admin"
                : role === "df55e59a-150c-4601-acc8-95e29683a39b"
                    ? "user"
                    : null;
            // ? "Administrador"
            // : role === "43a9809b-b893-4015-b424-430ac5a5c380"
            // ? "Editor"
            // : role === "5d9c451e-0195-4b4b-827f-a9935273261d"
            // ? "Leitor"
            // : "Nível de Acesso";
        },
        isGerente() {
            return this.role === "Gerente Relações";
        },
        isUsuario() {
            return this.role === "Usuário" || this.role === "Leitor";
        },
        isAdmin() {
            return this.role === "Administrador";
        },
        filteredUsuarios() {
            if (this.searchUsuarios != null) {
                return this.recentes.filter((item) => {
                    return item.first_name.startsWith(this.searchUsuarios);
                });
            } else {
                return this.recentes;
            }
        },
        intBreakPoint() {
            switch (this.$vuetify.breakpoint.name) {
                case "xs":
                    return 0;
                case "sm":
                    return 1;
                case "md":
                    return 2;
                case "lg":
                    return 3;
                case "xl":
                    return 4;
                default:
                    return 0;
            }
        },
    },
    methods: {
        buscaCEP() {
            let cepStr = this.address.cep;
            this.loadingCEP = true
            if (cepStr != undefined) {
                var cep = cepStr.replace(/\D/g, "");
                //Expressão regular para validar o CEP.
                var validacep = /^[0-9]{8}$/;
                //Valida o formato do CEP.
                if (validacep.test(cep)) {
                    fetch("https://viacep.com.br/ws/" + cep + "/json")
                        .then((response) => response.json())
                        .then((data) => {
                            this.address.cidade = data.localidade;
                            this.address.pais = "BR";
                            this.address.estado = data.uf;
                            this.address.bairro = data.bairro;
                            this.address.rua = data.logradouro;
                            this.loadingCEP = false

                        });
                }
                return cep;
            }
        },
        reloadAvatar(changedAvatar) {
            if (this.user.avatar != null) {
                let time = changedAvatar ? "&timestamp=" + new Date().getTime() : "";
                this.$http({
                    url: "assets/" + this.user.avatar + time,
                    responseType: "blob",
                }).then((response) => {
                    let reader = new FileReader();
                    reader.readAsDataURL(response.data);
                    reader.onload = () => {
                        this.avatarData = reader.result;
                        // x + 1 === comentariosLength ? this.$forceUpdate() : "";
                    };
                });
            } else {
                this.avatarData = require("../assets/icon-person.svg");
            }
        },
        async getUserLoggedPayments() {
            try {
                const { data } = await this.$http.get("payment/subscriptions");

                this.subscriptions = data.filter(
                    (subscription) => subscription.status !== "canceled"
                    // () => true
                );
            } catch (error) {

                // window.console.error(error);
            }
        },
        async deleteSubscription(id) {
            try {
                const deleteConfirm = confirm(
                    "Tem certeza que deseja cancelar sua assinatura?"
                );

                if (!deleteConfirm) {
                    return;
                }

                await this.$http.delete(`payment/subscriptions/${id}`);

                const index = this.subscriptions.findIndex(
                    (subscription) => subscription.id === id
                );
                if (index !== -1) {
                    this.subscriptions.splice(index, 1);
                    this.$http.patch("users/" + this.user.id, { plano: "plano-free" }).then(() => { })
                }
                window.console.error("removido com sucesso");
            } catch (error) {
                window.console.error(error);
            }
        },
        newAvatar() {
            const formData = new FormData();
            formData.append("file", this.files);
            this.$http
                .post("/files", formData, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                })
                .then((response) => {
                    if (response.data.data.id === this.user.avatar) {
                        window.alert("Avatar atualizado com sucesso");
                        this.user.avatar = response.data.data.id;
                        this.salvarUsuario();
                        this.reloadAvatar(true);
                    }
                });
        },
        updateAvatar() {
            if (confirm("Você deseja trocar sua foto de perfil ? ")) {
                var formData = new FormData();
                formData.append("file", this.files);
                this.$http
                    .patch("files/" + this.user.avatar, formData, {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                    })
                    .then((response) => {
                        //window.console.log(response)
                        if (response.data.data.id === this.user.avatar) {
                            window.alert("Avatar atualizado com sucesso");
                            this.reloadAvatar(true);
                        }
                    });
            }
        },
        loadAvatarRecentes() {
            // let recentesLength = this.recentes.length
            this.recentes.forEach((p) => {
                if (p.avatar != null) {
                    this.$http({ url: "assets/" + p.avatar, responseType: "blob" }).then(
                        (response) => {
                            let reader = new FileReader();
                            reader.readAsDataURL(response.data);
                            reader.onload = () => {
                                this.avatar[p.id] = reader.result;
                                this.$forceUpdate();
                            };
                        }
                    );
                } else {
                    this.avatar[p.id] = require("../assets/icon-person.svg");
                }
            });
        },
        salvarUsuario() {
            // e.preventDefault();
            this.$http.patch("users/" + this.user.id, this.user).then((response) => {
                if (response.data.data.id == this.user.id) {
                    alert("Usuário salvo com sucesso");
                }
            });
        },
        getConsuption() {
            this.$http({
                //&deep[documento][_aggregate][sum]=filesize
                url: "items/documentos?fields=*,documento.*&filter[id_user][_eq]=" + this.$store.state.user.id + "&filter[status][_eq]=published",
            }).then(
                (res) => {
                    this.arquivos = res.data.data;
                    this.arquivos.map(el => {
                        this.sizeFiles += el.documento.filesize
                        // x = (100 * usado ) / maximo

                        this.sizeFilesPercent = (this.sizeFiles * 100) / this.maxStorage
                    })
                    this.loadingArquivos = false;
                },
                (err) => {
                    window.console.log(err);
                }
            );
        },
        handleImageAdded(file) {
            window.console.log(file);
            const formData = new FormData();
            formData.append("image", file);
            this.$http
                .post("/files", formData, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                })
                .then((response) => {
                    window.console.log(response);
                    this.idNewAvatar = response.data.data.id
                    let newAvatar = {
                        avatar: this.idNewAvatar
                    }
                    this.$http.patch(`users/${this.$store.state.user.id}`, newAvatar).then((res) => {
                        window.console.log(res)
                        location.reload()
                    }).catch((err) => {
                        window.console.log(err)
                    })
                })
                .catch((err) => {
                    window.console.log(err);
                });
        },
        handleImageCapa(file) { 
            const formData = new FormData();
            formData.append("image", file);
            this.$http
                .post("/files", formData, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                })
                .then((response) => {
                    window.console.log(response);
                    this.idNewCapa = response.data.data.id
                    let newCapa = {
                        capa: this.idNewCapa
                    }
                    this.$http.patch(`users/${this.$store.state.user.id}`, newCapa).then((res) => {
                        window.console.log(res)
                        location.reload()
                    }).catch((err) => {
                        window.console.log(err)
                    })
                })
                .catch((err) => {
                    window.console.log(err);
                });
        },
        updateUser() {
            let userUp = {
                first_name: this.first_name,
                email: this.email,
                tags: [this.tags],
                apelido: this.nickname,
                sobre: this.descricao
            }
            this.$http.patch(`/users/${this.$store.state.user.id}`, userUp)
                .then((res) => {
                    window.console.log(res)
                    this.disabledCondition=false
                    this.$store.dispatch("getInfo")
                    alert("Perfil salvo com sucesso")
                    // location.reload()
                }).catch((err) => {
                    window.console.log(err)
                })
        },
        postAddress() {
            let addressUp = {
                cep: this.address.cep,
                estado: this.address.estado,
                cidade: this.address.cidade,
                bairro: this.address.bairro,
                rua: this.address.rua,
                numero: this.address.numero,
                complemento: this.address.complemento
            }
            if (this.address.id == "") {
                this.$http.post(`/items/endereco`, addressUp)
                    .then(() => {
                        alert(`endereço salvo com sucesso`)
                        // window.console.log(res)
                    }).catch((err) => {
                        window.console.log(err)
                    })
            }
            if (this.address.id.length > 0) {
                this.$http.patch(`/items/endereco/${this.address.id}`, addressUp)
                    .then(() => {
                        alert(`endereço salvo com sucesso`)
                        // window.console.log(res)
                    }).catch((err) => {
                        window.console.log(err)
                    })
            }
        },
        getAddress() {
            this.$http.get(`/items/endereco?filter[user_created][_eq]=${this.user.id}`).then((res) => {
                const ends = res.data.data
                if (ends.length > 0) this.address = res.data.data[0]
            })
        },
        async changeSubscription() {
            try {
                this.loadingPlano = true
                await this.$http.post("payment/subscriptions/change",
                    {
                        subscription_id: this.subscriptions[1].id,
                        plan_id: this.user.plano === `plano-carreira` ? `plan_48jmqoxfpH5OzQ0P` : `plan_vZJkelpIwIyeNq1M`,
                        quantity: this.updatePlan.quantity / 10
                    })
                this.getUserLoggedPayments()
                this.editPlano = false
                this.loadingPlano = false
            }
            catch (e) {
                // window.console.log(e)
                this.loadingPlano = false

            }
        }
    },
    filters: {
        plan: function (value) {
            switch (true) {
                case (value === "plano-free"):
                    return "Plano Free";
                case (["plano-avancado", "plano_avancado", "plano-carreira", "plan_XV7BG26TbcJoKxYv"].indexOf(value) >= 0):
                    return "Plano Carreira";
                case (["plano-premium", "plan_3B1DKr3HVqUp8LG5"].indexOf(value) >= 0):
                    return "Plano Premium";
                default:
                    return "Plano Free";
            }
        }
    }
};
</script>
